import { render, staticRenderFns } from "./home_shop.vue?vue&type=template&id=5ac7c3cd&scoped=true&"
import script from "./home_shop.vue?vue&type=script&lang=js&"
export * from "./home_shop.vue?vue&type=script&lang=js&"
import style0 from "./home_shop.vue?vue&type=style&index=0&id=5ac7c3cd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac7c3cd",
  null
  
)

export default component.exports